function LoaderWithLogo() {
  return (
    <div className="app-loader">
      <img src="/food/logo.png" width="270" height="160" alt="Cargill Logo" />
      <div className="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export default LoaderWithLogo;
